import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navigation = ({ 
  user, 
  onLogout, 
  isCartOpen, 
  setIsCartOpen, 
  getTotalItems 
}) => {
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <i className="fas fa-utensils me-2"></i>TastyBites
        </Link>
        
        <div className="collapse navbar-collapse" id="navbarContent">
          <span className="navbar-text ms-auto">
            Table #12 • 4 Guests
          </span>
          
          {/* Login/User Section */}
          <div className="d-flex align-items-center ms-3">
            {user ? (
              <div className="dropdown">
                <button 
                  className="btn btn-outline-light dropdown-toggle" 
                  type="button" 
                  data-bs-toggle="dropdown"
                >
                  <i className="fas fa-user me-1"></i> {user.name}
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <button className="dropdown-item" onClick={() => navigate('/profile')}>
                      <i className="fas fa-user me-2"></i>Profile
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => navigate('/orders')}>
                      <i className="fas fa-history me-2"></i>Order History
                    </button>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <button className="dropdown-item" onClick={handleLogoutClick}>
                      <i className="fas fa-sign-out-alt me-2"></i>Logout
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              <button 
                className="btn btn-outline-light me-2" 
                onClick={() => navigate('/login')}
              >
                <i className="fas fa-sign-in-alt me-1"></i> Login
              </button>
            )}
            
            {/* Cart Button */}
            <button 
              className="btn btn-outline-light position-relative ms-2" 
              onClick={() => setIsCartOpen(!isCartOpen)}
            >
              <i className="fas fa-shopping-cart"></i>
              {getTotalItems && getTotalItems() > 0 && (
                <span className="cart-badge">{getTotalItems()}</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;